import React from 'react';
import { R } from '@leverege/value-resolver';
import LinkCellRenderer from './LinkCell';
import ColorOption from '../../../views/pairing/editor/ColorOption';
import { LocatorStatus, Type, ReconciliationStatus, RecovrProductsSold, SaleVoidedBy } from '../sale';
import { SwatchAndColor, AlertPopup, VehicleDTCAlertsHistory, TagIdPopUp } from '../vehicle';
import OperationState from '../locator/OperationState';
import OperationStateChangeStatus from '../locator/OperationStateChangeStatus';
import FirmwareStatus from '../fota/FirmwareStatus';
import ResetRequestState from '../locator/ResetRequestState';
import AutoLocationTransferZone from '../locator/AutoLocationTransferZone';
import SaleState from '../sale/SaleState';
import ContractState from '../contract/ContractState';
import { BillState, PaymentStatusRenderer, AddendumChargesRenderer, AddendumCreditsRenderer, TotalDueRenderer, TotalPaidRenderer } from '../billing';
import BillLocationAddressRenderer from '../billing/BillLocationAddressRenderer';
import { alertLabels, alertVariants } from '../../attributes/CalculatedAlerts';
import { GracePeriod, GraceEndDate, SellThroughRate, PeriodPerformance } from '../location';
import createAlertVariant from '../Util';
import BillLocationIntercomIdRenderer from '../billing/BillLocationIntercomIdRenderer';
export default {
  install(molten) {
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.color',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(ColorOption, {
            option: {
              value: data.value
            }
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.swatchAndColor',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(SwatchAndColor, {
            value: data.value,
            object: Array.isArray(context.target) ? context.target[0] : null,
            style: props.style,
            swatchStyle: {},
            variant: 'columnValue'
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.locator$locator.zone.name',
      renderer: (data, props, context) => {
        if (data) {
          return /*#__PURE__*/React.createElement(AutoLocationTransferZone, {
            value: data.value,
            object: Array.isArray(context.target) ? context.target[0] : null,
            isVehicle: true
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'locator',
      attrName: 'locator.zone.name',
      renderer: (data, props, context) => {
        if (data) {
          return /*#__PURE__*/React.createElement(AutoLocationTransferZone, {
            value: data.value,
            object: Array.isArray(context.target) ? context.target[0] : null
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'companyContract',
      attrName: 'companyContract.calculatedContractState',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(ContractState, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'bill',
      attrName: 'bill.sellThroughRate',
      renderer: (data, props, context) => {
        if (data.value !== undefined) {
          return /*#__PURE__*/React.createElement(BillState, {
            value: data.value,
            context
          });
        }
        return null;
      }
    });

    // sale stuff
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'sale',
      attrName: 'sale.locator.status',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(LocatorStatus, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'sale',
      attrName: 'sale.state',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(SaleState, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'sale',
      attrName: 'sale.type',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(Type, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'locator',
      attrName: 'locator.events.resetRequestState',
      renderer: (data, props, object, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(ResetRequestState, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'locator',
      attrName: 'locator.reportedOperationState',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(OperationState, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.locator$locator.reportedOperationState',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(OperationState, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'locator',
      attrName: 'locator.desiredOperationState',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(OperationState, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.locator$locator.desiredOperationState',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(OperationState, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.calculatedAlerts',
      renderer: (data, props, context) => {
        const vin = context?.target?.[0]?.data?.data?.vin;
        if (data.value) {
          return /*#__PURE__*/React.createElement(AlertPopup, {
            value: data.value,
            vin,
            alertLabels: R(alertLabels),
            alertVariants,
            defaultFirstPillVariant: 'pillError',
            defaultLastPillVariant: 'pillError',
            table: true
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'vehicle',
      attrName: 'vehicle.dtcAlerts',
      renderer: (data, props, context) => {
        const vin = context?.target?.[0]?.data?.data?.vin;
        if (data.value) {
          return /*#__PURE__*/React.createElement(AlertPopup, {
            value: data.value,
            vin,
            defaultFirstPillVariant: 'pillDTC',
            defaultLastPillVariant: 'pillWarning',
            table: true
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'vehicle.history',
      attrName: 'vehicle.dtcAlerts.history',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(VehicleDTCAlertsHistory, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'locator',
      attrName: 'locator.operationStateChangeStatus',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(OperationStateChangeStatus, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'locator',
      attrName: 'locator.firmware.status',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(FirmwareStatus, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'locator',
      attrName: 'locator.businessState',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(LocatorStatus, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'sale',
      attrName: 'sale.reconciliation.status',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(ReconciliationStatus, {
            value: data.value
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'bill',
      attrName: 'bill.totalCharges',
      renderer: (data, props, context) => {
        const original = data.row?.original;
        return /*#__PURE__*/React.createElement(AddendumChargesRenderer, {
          original,
          context,
          ...props
        });
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'bill',
      attrName: 'bill.totalCredits',
      renderer: (data, props, context) => {
        const original = data.row?.original;
        return /*#__PURE__*/React.createElement(AddendumCreditsRenderer, {
          original,
          context,
          ...props
        });
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'bill',
      attrName: 'bill.totalPaid',
      renderer: (data, props, context) => {
        const original = data.row?.original;
        return /*#__PURE__*/React.createElement(TotalPaidRenderer, {
          original,
          context,
          ...props
        });
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'bill',
      attrName: 'bill.totalDue',
      renderer: (data, props, context) => {
        const original = data.row?.original;
        return /*#__PURE__*/React.createElement(TotalDueRenderer, {
          original,
          context,
          ...props
        });
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'bill',
      attrName: 'bill.paymentStatus',
      renderer: (data, props, context) => {
        const original = data.row?.original;
        return /*#__PURE__*/React.createElement(PaymentStatusRenderer, {
          original,
          context,
          ...props
        });
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'bill',
      attrName: 'bill.locationAddress',
      renderer: (data, props, context) => {
        const original = data.row?.original;
        return /*#__PURE__*/React.createElement(BillLocationAddressRenderer, {
          original,
          context,
          ...props
        });
      }
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'bill',
      attrName: 'bill.recovr-invoice.invoiceId',
      renderer: LinkCellRenderer,
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'payment',
      attrName: 'payment.recovr-payment.paymentId',
      renderer: LinkCellRenderer,
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'location',
      attrName: 'location.gracePeriod',
      renderer: GracePeriod,
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'location',
      attrName: 'location.graceEndDate',
      renderer: GraceEndDate,
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'location',
      attrName: 'location.sellThroughRate',
      renderer: SellThroughRate,
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'location',
      attrName: 'location.sevenDayPerformance',
      renderer: PeriodPerformance,
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'location',
      attrName: 'location.thirtyDayPerformance',
      renderer: PeriodPerformance,
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'sale',
      attrName: 'sale.recovrProductsSold',
      renderer: (data, props, context) => {
        return /*#__PURE__*/React.createElement(RecovrProductsSold, {
          original: data.row?.original,
          context,
          ...props,
          value: data.value
        });
      },
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'sale',
      attrName: 'sale.tagIds',
      renderer: (data, props, context) => {
        const vin = data.row.original.data?.data?.vehicle?.vin;
        const alertVariants = data.value ? data.value.map(value => createAlertVariant(data.row.original.data?.data?.keys, value)) : [];
        return /*#__PURE__*/React.createElement(TagIdPopUp, {
          value: data.value,
          vin,
          alertVariants,
          table: true
        });
      },
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'sale',
      attrName: 'sale.voidedBy',
      renderer: (data, props, context) => {
        return /*#__PURE__*/React.createElement(SaleVoidedBy, {
          original: data.row?.original,
          context,
          ...props,
          value: data.value
        });
      },
      handles: () => true
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'bill',
      attrName: 'bill.locationIntercomId',
      renderer: (data, props, context) => {
        const original = data.row?.original;
        return /*#__PURE__*/React.createElement(BillLocationIntercomIdRenderer, {
          original,
          context,
          ...props
        });
      }
    });
  }
};